"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cachedFilters = {};
var cachedData = {};
var memoryStore = {
    getFilter: function (namespace) {
        return cachedFilters[namespace];
    },
    saveFilter: function (namespace, filter) {
        cachedFilters[namespace] = filter;
    },
    getData: function (namespace) {
        return cachedData[namespace];
    },
    saveData: function (namespace, data) {
        cachedData[namespace] = data;
    },
    clear: function () {
        cachedFilters = {};
        cachedData = {};
    },
};
exports.default = memoryStore;
